import { Component } from '@angular/core';
import {
  NavController,
  ToastController,
  ModalController,
  NavParams,
  ViewController,
  AlertController,
  Events
} from 'ionic-angular';
import { Params } from '../params';
import { FormBuilder, FormGroup,Validators } from '@angular/forms';
import * as firebase from 'firebase/app';
import { GlobalProvider } from "../../providers/global/global";
import {Http} from "@angular/http";
import { ChangeDetectorRef } from '@angular/core';


@Component({
  selector: 'page-foods',
  templateUrl: 'foods.html'
})
export class FoodsPage {
  money = Params.money;
  foods = [];
  disc = Params.disc;
  constructor(
    public navCtrl: NavController,
    public global: GlobalProvider,
    private toastCtrl : ToastController,
    private modalCtrl : ModalController,
    private alertCtrl : AlertController,
    private ref: ChangeDetectorRef,
    public events: Events) {

    this.foods = this.global.foods.filter((x) => x.active);

    events.subscribe('foods:ready', () => {
      this.foods = this.global.foods.filter((x) => x.active);
      this.ref.detectChanges()
    });

  }

  editPrice(food){
    const prompt = this.alertCtrl.create({
      title: 'Asignar precio a '+food.name,
      inputs: [
        {
          name: 'price',
          placeholder: 'Valor de venta',
          type: "number",
          value: food.price
        },
      ],
      buttons: [
        {
          text: 'Cancelar',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Asignar Precio',
          handler: data => {
            console.log(food.value);
             firebase.firestore().collection('foods')
              .doc(food.value)
              .set({
                price: data.price
              })
              .then(()=>{
                food.price = data.price;
                let toast = this.toastCtrl.create({
                  message: 'Precio '+data.price+' asignado exitosamente',
                  duration: 3000
                });
                toast.present();
              })
            console.log(data);
          }
        }
      ]
    });
    prompt.present();
  }

  newFood(food) {
    let params = {};
    params["food"] = food;
    let modal = this.modalCtrl.create(FoodPage, params);
    modal.present();
  }

  update(key,value,field){
    let obj = {};
    obj[field] = value;
    // this.foods.update(key, obj);
  }

  deletePlan(key){
    // this.foods.remove(key);
  }
}
@Component({selector: 'page-food', templateUrl: 'food.html'})
export class FoodPage {
  title:string;
  edit : boolean = false;
  foods:any;
  addForm: FormGroup;
  constructor(
    public params: NavParams,
    public viewCtrl: ViewController,
    private builder: FormBuilder,
    public toastCtrl: ToastController
  ) {

    this.addForm = builder.group({
      'code': ['', Validators.required],
      'name': ['', Validators.required],
      'prize': [''],
      'active' : [true],
      'tag' : [true]
    })
    this.title = "Nueva Comida";
    let food = this.params.get("food");
    if(food){
      this.edit = true;
      this.title = "Editar Comida";
      this.addForm = builder.group({
        'code': [food["$key"], Validators.required],
        'name': [food["name"], Validators.required],
        'prize': [food["prize"] ],
        'active': [food["active"], Validators.required],
        'tag': [food["tag"]],
      })
    }
  }

  save() {
    let data = this.addForm.value;
    let code = Params.key_parse(data.code);
    let food = {
      name : data.name,
      prize : data.prize.replace(/\./g, ""),
      active: data.active,
      tag : data.tag,
      key : code
    };
    /* this.food = this.db.object('foods/'+code);
    this.food.set(food).then(_ => {
      let word = "creada";
      if(this.edit) word = "editada";
      let toast = this.toastCtrl.create({
        message: 'Comida '+data.name+' '+word+' exitosamente',
        duration: 3000
      });
      toast.present();
    }); */

    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/foods/foods.ts